import type { CountryCodeAlpha2 } from "@shared/generated/graphql/chargetrip";
import type { UserLocation } from "@shared/store/ui/types";
import { Temporal } from "@js-temporal/polyfill";

export const fetchUserLocation = async (): Promise<UserLocation> => {
  const res = await fetch(
    `https://d2gm914xldfshu.cloudfront.net/index.json?t=${Temporal.Now.instant().epochMilliseconds}`,
  );

  return {
    country: res.headers.get("x-country") as CountryCodeAlpha2,
    latitude: Number(res.headers.get("x-latitude")),
    longitude: Number(res.headers.get("x-longitude")),
  };
};
